import { useAuthContext } from '@/auth/useAuthContext';
import { formatPriceMinor } from '@/lib/format';
import type { ServiceCatalogueItem } from '@/lib/types';
import { cn } from '@/lib/utils';

interface Props {
  service: ServiceCatalogueItem;
  selected: boolean;
  onToggle: () => void;
}

export function ServiceCard({ service, selected, onToggle }: Props) {
  const { state } = useAuthContext();
  const currency = state.me?.activeAccount?.currency ?? 'GBP';
  const locale = state.me?.activeAccount?.locale ?? 'en-GB';
  const price = service.priceMinor ?? service.defaultPriceMinor;

  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        'flex flex-col gap-1 rounded-xl border p-3 text-left press transition-colors',
        selected
          ? 'border-primary bg-primary/10 ring-1 ring-primary/30'
          : 'border-border bg-surface hover:bg-secondary',
      )}
    >
      <span
        className={cn(
          'text-xs font-medium leading-snug',
          selected ? 'text-primary' : 'text-foreground',
        )}
      >
        {service.name}
      </span>
      <span
        className={cn('num text-[10.5px]', selected ? 'text-primary/70' : 'text-muted-foreground')}
      >
        {formatPriceMinor(price, currency, locale)}
      </span>
    </button>
  );
}
